import * as React from 'react';
import { Label, Input, Row, Col } from 'reactstrap';
import { getValue } from '../../core/lodash';
import PreviewAdvancedOptions from './previewAdvancedOptions';

interface ICheckboxGridProps {
  questions: object;
  // validation
  required: boolean;
  answer: any;
  handleChangeTakeSurveyAdvancedOptionInput: (
    e: any,
    questionId: string,
    param: string
  ) => void;
  handleUserSurveyResponseDropdownGrid: (
    questionId: string,
    questionType: string,
    rowId: string,
    columnId: string
  ) => void;
  requiredErrors: any;
}

const CheckboxGrid: React.FunctionComponent<ICheckboxGridProps> = (props) => {
  let selected = getValue(props, 'answer', []).filter((item) => {
    return item.questionId === getValue(props, 'questions.id', '');
  });
  return (
    <>
      <table className="table table-borderless">
        {getValue(props.questions, `row`, []).map((rowData, i) => {
          return (
            <>
              {i === 0 ? (
                <thead>
                  <tr>
                    <td></td>
                    {getValue(props.questions, `columns`, []).map((item) => {
                      return (
                        <td className="text-center">
                          <p className="mb-0 text-capitalize">
                            {getValue(item, `text`, '')}
                          </p>
                        </td>
                      );
                    })}
                  </tr>
                </thead>
              ) : (
                ''
              )}
              <tbody>
                <tr>
                  <td>
                    <p className="mb-0 text-capitalize">
                      {getValue(rowData, 'text', '')}
                    </p>
                  </td>
                  {getValue(rowData, 'columns', '').map((item, index) => {
                    return (
                      <td className="text-center">
                        <div className="form-group mb-0">
                          <Label className="checkbox-container d-inline-block pl-4 ml-1">
                            <Input
                              type="checkbox"
                              placeholder="Enter here"
                              checked={
                                getValue(selected[0], 'response', []).filter(
                                  (items) => {
                                    return (
                                      getValue(items,`rowId`,'') === rowData.id &&
                                      getValue(item,`id`,'') === items.columnId &&
                                      items.columnId !== ''
                                    );
                                  }
                                ).length > 0
                              }
                              onChange={() => {
                                props.handleUserSurveyResponseDropdownGrid(
                                  getValue(selected[0], 'questionId', ''),
                                  getValue(props.questions, 'type', ''),
                                  rowData.id,
                                  item.id
                                );
                              }}
                            />
                            <span className="checkmark"></span>
                          </Label>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </>
          );
        })}
      </table>
      <PreviewAdvancedOptions
        questions={props.questions}
        answer={props.answer}
        handleChangeTakeSurveyAdvancedOptionInput={
          props.handleChangeTakeSurveyAdvancedOptionInput
        }
      />

      <div className="form-error" style={{ color: 'red' }}>
        {props.requiredErrors.includes(getValue(props, 'questions.id', ''))
          ? getValue(props.questions, 'mandatoryMsg', '')
          : ''}
      </div>
    </>
  );
};

export default CheckboxGrid;
